import { render } from "./ExternalAuditPage.vue?vue&type=template&id=232d37a6"
import script from "./ExternalAuditPage.vue?vue&type=script&lang=js"
export * from "./ExternalAuditPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__